"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bob = exports.bsquared = exports.bsc = exports.polygon = void 0;
exports.polygon = {
    mainnet: {
        uniswapV3ConnectorAddress: "0x4e3e1807aa17aed8d1FC580dDa552079d9427ece",
        uniswapV2ConnectorAddress: "0x0C28968d8A3Af022F47D493402D35Cb42EFF0597",
        uniswapV2FactoryAddress: "0x5757371414417b8C6CAad45bAeF941aBc7d3Ab32",
        uniswapV2RouterAddress: "0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff",
        priceOracleAddress: "0x4Dc0109036b7d500dB30150A8f52744772256e25",
        relayAddress: "0x7DeB66341b1d499D7e699589d0cf665De4132EA3",
        ccTransferAddress: "0x04367D74332137908BEF9acc0Ab00a299A823707",
        ccExchangeAddress: "0xD1E9Ff33EC28f9Dd8D99E685a2B0F29dCaa095a3",
        ccBurnAddress: "0x0009876C47F6b2f0BCB41eb9729736757486c75f",
        lockerAddress: "0xf5D6D369A7F4147F720AEAdd4C4f903aE8046166",
    },
    testnet: {
        uniswapV3ConnectorAddress: "",
        uniswapV2ConnectorAddress: "0xDCe382999fc164Ac915dBE50c561c7436b9557E1",
        uniswapV2FactoryAddress: "0x26C7eD58E18f2EC2bFa3eFBABA7a82368ea2957b",
        uniswapV2RouterAddress: "0xf0568b9E879ae5851406b7ACCF2D694f32a8B0fE",
        priceOracleAddress: "0xe32ABDD3A080ab0D42922FC6e64F1968876A148F",
        relayAddress: "0xa614aC06096D43eA30d887D60Ae48F86E19365B3",
        ccTransferAddress: "0x1Bb3e2d7C143E2a1F39bB2F667aCc26D38F070eb",
        ccExchangeAddress: "0x588889B3fD0095566085c48214A1F2805d72084a",
        ccBurnAddress: "0x53ADA34D465c80e38B8d8188023c3F9F08602b1F",
        lockerAddress: "0x95aeCD0b859228679b34E005db8A6B4be5097B54",
    },
};
exports.bsc = {
    mainnet: {
        uniswapV3ConnectorAddress: "0xE8e8BFd780d9401E1C10530BE897E85Eb269385B",
        uniswapV2ConnectorAddress: "0x856D80F77349F675Ea7E3477aD75Ef57349e777b",
        uniswapV2FactoryAddress: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
        uniswapV2RouterAddress: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
        priceOracleAddress: "0x7Aabb0779782247384A1C91844211516E93b1D63",
        relayAddress: "0xFcd688999c25D5493571543137cEeb4fbDb44D02",
        ccTransferAddress: "0xA38aD0d52B89C20c2229E916358D2CeB45BeC5FF",
        ccExchangeAddress: "0xcA5416364720c7324A547d39b1db496A2DCd4F0D",
        ccBurnAddress: "0x2787D48e0B74125597DD479978a5DE09Bb9a3C15",
        lockerAddress: "0x84F74e97ebab432CeE185d601290cE0A483987A5",
    },
    testnet: {
        uniswapV3ConnectorAddress: "",
        uniswapV2ConnectorAddress: "",
        uniswapV2FactoryAddress: "",
        uniswapV2RouterAddress: "",
        priceOracleAddress: "",
        relayAddress: "",
        lendingAddress: "",
        ccTransferAddress: "",
        ccExchangeAddress: "",
        ccBurnAddress: "",
        lockerAddress: "",
    },
};
exports.bsquared = {
    mainnet: {
        uniswapV3ConnectorAddress: "0x6a8e88a6a80b28b5427EA3eE110034FCa39d40DE",
        uniswapV2ConnectorAddress: "",
        uniswapV2FactoryAddress: "",
        uniswapV2RouterAddress: "",
        priceOracleAddress: "0x413e34727EB030dD8016033e375FE4497dA11e8F",
        relayAddress: "0xDd833309e9E9EAd3a7c4520D53e02e685C3751eB",
        ccTransferAddress: "0x9042B082A31343dFf352412136fA52157ff7fdC8",
        ccExchangeAddress: "0xE0166434A2ad67536B5FdAFCc9a6C1B41CC5e085",
        ccBurnAddress: "0x84da07E1B81e3125A66124F37bEA4897e0bB4b90",
        lockerAddress: "0x20752a82fe75996a582Ae2be1b7C3D4866C5b733",
    },
    testnet: {
        uniswapV3ConnectorAddress: "",
        uniswapV2ConnectorAddress: "",
        uniswapV2FactoryAddress: "",
        uniswapV2RouterAddress: "",
        priceOracleAddress: "",
        relayAddress: "",
        ccTransferAddress: "",
        ccExchangeAddress: "",
        ccBurnAddress: "",
        lockerAddress: "",
    },
};
exports.bob = {
    mainnet: {
        iZiSwapV3ConnectorAddress: "0xDd833309e9E9EAd3a7c4520D53e02e685C3751eB",
        uniswapV3ConnectorAddress: "0xDd833309e9E9EAd3a7c4520D53e02e685C3751eB",
        uniswapV2ConnectorAddress: "",
        uniswapV2FactoryAddress: "",
        uniswapV2RouterAddress: "",
        priceOracleAddress: "0x0ddEc933F6e42e6a5D31a5ec58c08DDC3f92b278",
        relayAddress: "0xec4A7D93750BbcE2A07fd1bc748507ea645e9d52",
        ccTransferAddress: "0x25BEf4b1Ca5985661657B3B71f29c0994C36Bbba",
        ccExchangeAddress: "0xd724e5709dF7DC4B4dDd14B644118774146b9492",
        ccBurnAddress: "0x754DC006F4a748f80CcaF27C0efBfF412e54160D",
        lockerAddress: "0xd720996f0D8fFD9154c8271D2991f54E5d93D2A9",
    },
    testnet: {
        uniswapV3ConnectorAddress: "",
        uniswapV2ConnectorAddress: "",
        uniswapV2FactoryAddress: "",
        uniswapV2RouterAddress: "",
        priceOracleAddress: "",
        relayAddress: "",
        ccTransferAddress: "",
        ccExchangeAddress: "",
        ccBurnAddress: "",
        lockerAddress: "",
    },
};
//# sourceMappingURL=contracts-address.js.map